import React, { memo } from "react";
import { Box, Center, Grid } from "@chakra-ui/react";

interface IProps {
  bottomRightIcon?: JSX.Element;
  bottomRightIconSize?: number;
  bottomRightImageBackgroundColor?: string;
  centerImage?: JSX.Element;
  size?: [number, number];
}

const BORDER_RADIUS = 4;

const FileTypeThumb = ({
  bottomRightIcon,
  bottomRightIconSize = 8,
  bottomRightImageBackgroundColor,
  centerImage,
  size = [86, 86],
}: IProps) => {
  const width = `${size[0]}px`;
  const height = `${size[1]}px`;

  return (
    <Grid position="relative" minH={height} minW={width}>
      <Center>{centerImage}</Center>
      {bottomRightIcon && (
        <Box position="absolute" bottom={0} right={0}>
          <Center
            borderBottomRightRadius={BORDER_RADIUS}
            borderTopLeftRadius={BORDER_RADIUS}
            backgroundColor={bottomRightImageBackgroundColor}
            alignContent="center"
            w={bottomRightIconSize}
            h={bottomRightIconSize}
          >
            {bottomRightIcon}
          </Center>
        </Box>
      )}
    </Grid>
  );
};

export default memo(FileTypeThumb);
